export const withCdn = (url: string) => {
  const cdnUrl = import.meta.env.VITE_CDN_URL as string
  return `${cdnUrl}${url}`
}

export const withoutCdn = (url: string) => {
  const cdnUrl = import.meta.env.VITE_CDN_URL as string
  return url.replace(cdnUrl, '')
}
